import SettingsIcon  from "@mui/icons-material/Settings";
import DoneIcon  from "@mui/icons-material/Done";
import MoreHorizIcon  from "@mui/icons-material/MoreHoriz";
import { Chip } from "@mui/material";

interface SituacaProcessoChipProps {
    situacao: string
}

export default function SituacaoProcessoChip({ situacao }: SituacaProcessoChipProps) {

    switch(situacao){
        case 'Em análise': return (<Chip label="Em análise" variant="outlined" color="info" icon={<MoreHorizIcon />} />)
        case 'Em execução': return (<Chip label="Em execução" variant="outlined" color="warning" icon={<SettingsIcon />} />)
        case 'Finalizado': return (<Chip label="Finalizado" variant="outlined" color="success" icon={<DoneIcon />} />)
    }

    return <Chip label={situacao} variant="outlined" />
}